var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Link } from "@mui/material";
import { CopyField } from "./CopyField";
// Same height as the 3-row multiline CopyFields next to it (rows=3 -> 3 * 1.4375em line-height).
const THREE_ROWS_HEIGHT = "4.3125em";
const LinksInput = forwardRef(({ className, items = [] }, ref) => (_jsx("div", { ref: ref, className: className, style: {
        height: "auto",
        minHeight: THREE_ROWS_HEIGHT,
        boxSizing: "content-box",
        overflowWrap: "anywhere",
    }, children: items.map((item, idx) => item.url ? (_jsx(Link, { href: item.url, title: item.label, target: "_blank", rel: "noopener noreferrer", underline: "always", color: "primary", sx: { display: "block" }, children: item.label }, idx)) : (_jsx("span", { title: item.label, style: { display: "block" }, children: item.label }, idx))) })));
/**
 * Copy field that shows clickable links (or plain text) instead of an editable value.
 * The copy button copies every link (or the text when there is no link), one per line.
 */
export const LinksCopyField = (_a) => {
    var { items } = _a, rest = __rest(_a, ["items"]);
    return (_jsx(CopyField, Object.assign({}, rest, { value: items.map((item) => { var _a; return (_a = item.url) !== null && _a !== void 0 ? _a : item.label; }).join("\n"), inputComponent: LinksInput, htmlInputProps: { items }, shrinkLabel: items.length > 0 })));
};
